"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { SidebarComponent } from "@/components/sidebar/sidebar";
import SessionContext from "@/app/context/sessionContext";
import { auth } from "@/auth"; // adjust if needed or use an API route

export default function LayoutProvider({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const [session, setSession] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const router = useRouter();

    useEffect(() => {
        const fetchSession = async () => {
            try {
                const res = await fetch("/api/auth/session");
                const data = await res.json();
                if (!data?.user) {
                    router.push("/signin");
                } else {
                    setSession(data);
                }
            } catch {
                router.push("/signin");
            } finally {
                setLoading(false);
            }
        };

        fetchSession();
    }, []);

    if (loading) return <div>Loading...</div>;


    const hideSidebarRoutes = ["/signin", "/signout", "/register"];
    const hideSidebar = hideSidebarRoutes.some((route) => pathname?.startsWith(route));

    if (hideSidebar) {
        return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
    }

    return (
        <SessionContext.Provider value={session}>
            <SidebarComponent>{children}</SidebarComponent>
        </SessionContext.Provider>
    );
}
